import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import InfoBlockComponent from './InfoBlockComponent'

export interface IAttributes {
  illustration: string
  illustrationAlt?: string
  text: string
}

const InfoBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <InfoBlockComponent
      {...attributes}
      illustration={<LazyLoadImage src={attributes.illustration} alt={attributes.illustrationAlt} />}
    />
  )
}

export default InfoBlock
